import type { MenuUnstyledProps } from "@mui/base";
import { MenuUnstyled } from "@mui/base";
import type { FunctionComponent } from "react";

import { ListboxStyled } from "./styles";

export const Menu: FunctionComponent<MenuUnstyledProps> = ({ children, ...props }) => {
  const listbox = props.slots?.listbox ?? ListboxStyled;

  return (
    <MenuUnstyled {...props} slots={{ listbox }}>
      {children}
    </MenuUnstyled>
  );
};
